import { render, staticRenderFns } from "./MallDetails.vue?vue&type=template&id=d0cc9ada&scoped=true&"
import script from "./MallDetails.vue?vue&type=script&lang=ts&"
export * from "./MallDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MallDetails.vue?vue&type=style&index=0&id=d0cc9ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc9ada",
  null
  
)

export default component.exports